module.exports = __webpack_public_path__ + "img/24620388000191.6171080a.png";